import { Component, ChangeDetectionStrategy, output, input } from '@angular/core';

import { Column, Group } from '../../table';
import { CardComponent } from '../card.component';
import {
  DropdownComponent,
  DropdownButtonDirective,
  DropdownItemDirective,
} from '../../dropdown/dropdown.component';
import { TableComponent } from '../../table/table.component';
import { ChartLoaderDirective } from '../../loading/chart-loader-directive/chart-loader.directive';

@Component({
  selector: 'app-table-card',
  templateUrl: './table-card.component.html',
  styleUrls: ['./table-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CardComponent,
    DropdownComponent,
    DropdownButtonDirective,
    DropdownItemDirective,
    TableComponent,
    ChartLoaderDirective,
  ],
})
export class TableCardComponent {
  public readonly heading = input('');

  public get actionsLabel() {
    return `Table Actions for ${this.heading()}`;
  }

  public readonly empty = input(false);

  public readonly loading = input(true);

  public readonly download = output();

  public readonly dataId = input('');

  public readonly columns = input<Column[]>();

  public readonly groups = input<Group[]>();

  public readonly data = input<any>();

  public initiateDownload() {
    this.download.emit();
  }
}
